export * from './lib/detail-dialog.module';
export * from './lib/overview/overview.component';
export * from './lib/galleries/galleries.component';
export * from './lib/room/room.component';
export * from './lib/amenities/amenities.component';
